const ratePattern = /^\d{1,3}(\.\d{1,4})?$/;

export const validateRate = (value: string) => {
    const trimmed = value.trim();

    if (trimmed == '') {
        return 'Enter a tax rate';
    }

    if (!ratePattern.test(trimmed)) {
        return 'Use a number with up to 4 decimal places';
    }

    const rate = Number(trimmed);

    if (rate <= 0 || rate > 100) {
        return 'Must be greater than 0 and no more than 100';
    }

    return undefined;
};

export const formatRate = (rate: number) => `${Number(rate)}%`;

interface IProps {
    value: string,
    error?: string,
    autoFocus?: boolean,
    onChange: (value: string) => void,
    onEnter: () => void
}

const RateInput = ({ value, error, autoFocus, onChange, onEnter }: IProps) => (
    <div className={error ? 'has-error' : undefined}>
        <div className='file-input-group'>
            <input
                type='text'
                inputMode='decimal'
                className='form-control'
                aria-label='Tax rate percent'
                placeholder='0.0000'
                value={value}
                autoFocus={autoFocus}
                style={{ color: '#1F2A37', textAlign: 'right' }}
                onChange={e => onChange(e.currentTarget.value)}
                onKeyDown={e => {
                    if (e.key == 'Enter') {
                        onEnter();
                    }
                }}
            />
            <span className='btn' style={{ cursor: 'default', padding: '6px 12px' }}>%</span>
        </div>
        {error && <div className='help-block'>{error}</div>}
    </div>
);

export default RateInput;
